(() => {
  const containerSelector = '.AjaxinateContainer';
  const paginationSelector = '#AjaxinatePagination';
  let loading = false;

  const observer = new IntersectionObserver(
    (entries) => {
      if (entries.some((entry) => entry.isIntersecting)) loadNextPage();
    },
    { rootMargin: '400px 0px' }
  );

  async function loadNextPage() {
    if (loading) return;

    const container = document.querySelector(containerSelector);
    const pagination = document.querySelector(paginationSelector);
    const nextLink = pagination?.querySelector('a[href]');

    if (!container || !pagination || !nextLink) {
      if (pagination) observer.unobserve(pagination);
      return;
    }

    loading = true;
    const originalText = nextLink.textContent;
    nextLink.textContent = 'Loading…';

    try {
      const response = await fetch(nextLink.href, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });

      if (!response.ok) throw new Error(`Unable to load products (${response.status})`);

      const page = new DOMParser().parseFromString(await response.text(), 'text/html');
      const newContainer = page.querySelector(containerSelector);
      const newPagination = page.querySelector(paginationSelector);

      if (!newContainer || !newPagination) throw new Error('Pagination markup was not found');

      container.insertAdjacentHTML('beforeend', newContainer.innerHTML);
      pagination.innerHTML = newPagination.innerHTML;

      document.querySelectorAll('.loading-image').forEach((image) => {
        image.classList.remove('loading-image');
        image.classList.add('loaded-image');
      });

      if (!pagination.querySelector('a[href]')) observer.unobserve(pagination);
    } catch (error) {
      nextLink.textContent = originalText;
      console.error('Collection infinite scroll:', error);
    } finally {
      loading = false;
    }
  }

  function initialize() {
    const pagination = document.querySelector(paginationSelector);
    if (!pagination) return;

    observer.observe(pagination);

    // Prevent the deferred legacy bundle from starting a second paginator.
    window.collectionInfiniteScroll = { observer, loadNextPage };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
